import { render, staticRenderFns } from "./CharacterManagement.vue?vue&type=template&id=fed13144&scoped=true"
import script from "./CharacterManagement.vue?vue&type=script&lang=js"
export * from "./CharacterManagement.vue?vue&type=script&lang=js"
import style0 from "./CharacterManagement.vue?vue&type=style&index=0&id=fed13144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed13144",
  null
  
)

export default component.exports